import { BillRepository } from "../../repositories/BillRepository";
import { BillOperationResult, BillDataEntity } from "../../entities/BillEntity";
import type { ApprovalAuditPayload } from "../../../../../shared/utils/reviewWorkflow";

/**
 * Update Zoho Bill Use Case
 * Updates an existing bill in Zoho Books
 */
export class UpdateZohoBillUseCase {
  constructor(private repository: BillRepository) {}

  async execute(
    billId: string,
    billData: BillDataEntity,
    approvalAudit?: ApprovalAuditPayload,
  ): Promise<BillOperationResult> {
    // Validate inputs
    // if (!billId || billId.trim() === "") {
    //   throw new Error("Bill ID is required");
    // }

    // if (!billData) {
    //   throw new Error("Bill data is required");
    // }

    // // Validate required bill data
    // if (!billData.vendor_id || billData.vendor_id.trim() === "") {
    //   throw new Error("Vendor ID is required");
    // }

    // if (!billData.bill_number || billData.bill_number.trim() === "") {
    //   throw new Error("Bill number is required");
    // }

    return await this.repository.updateZohoBill(billId, billData, approvalAudit);
  }
}
